import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import Buttons from '../../Buttons';
import $ from 'jquery';
import Wrp from '../../../../hoc/Wrp/Wrp';
import { warningMessage } from '../../../../store/actions';
import { connect } from 'react-redux';

class Setting extends Component {
  
    componentDidMount(){
      
    }
    render () {
      const {colData,id,header} = this.props;
      const eventsHandler = {
  onClick: (e) => {

    const windows = colData?.param?.data?.windows;

    // Identify current window/module
    const isTagWindow = window.location.pathname.includes("tags");

    // Show message only for Tags window
    if (isTagWindow && (!windows || windows.length === 0)) {

        e.preventDefault();

        this.props.dispatch(
            warningMessage("Selected tag is not assigned to any window")
        );

        return false;
    }

    // Existing functionality
    if (colData.clickHandler) {
        colData.clickHandler(colData, colData.attributes);
    }

    return 'javascript(void)';
}
}
      const access_mode = (colData.access_mode==undefined)? true:colData.access_mode;
      // console.log(colData);
      const href = (colData.href) ? colData.href:"#";
        return(
            <td key={"column"+this.props.id}>
              {(access_mode==true)? 
                <LinkContainer key={id} to={href} {...eventsHandler}>
                  <a {...header.attributes} {...colData.attributes}>
                    <span className='tbodyTitle text-info textUnderline' title={colData.value}>
                        {colData.value} 
                    </span>
                  
                </a>
                </LinkContainer>
              :''}
              {(colData.setting.actionMore != undefined && colData.setting.actionMore.length>0)?
                <div className="pl-2 btn-group dropright hidden-caret">
                    <div className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fas fa-cog fa-lg third_dark_color fa-spin" style={{visibility: "hidden"}}></i>
                    </div> 
                    <ul className="dropdown-menu border p-0 m-0" >
                        {colData.setting.actionMore.map((button,btnIndex)=>{
                            return(
                              <Wrp key={btnIndex}>
                                {
                                  button !== '' ?
                                    <li key={btnIndex}> 
                                        <Buttons buttonList={[button]} />
                                    </li>
                                  : null
                                }
                              </Wrp>
                            )
                        })}
                    </ul> 
                </div>
              :colData.setting.customPopup?
                colData.setting.customPopup[0].popupData.length > 0 ?
                <div className="pl-2 btn-group dropright hidden-caret">
                    <div className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fas fa-cog fa-lg third_dark_color fa-spin" style={{visibility: "hidden"}}></i>
                    </div> 
                    <div className="dropdown-menu dropdown-user border p-2 m-0 fixed-height overflowY-auto" >
                        {colData.setting.customPopup[0].popupData}
                    </div>  
                </div>    
                : null    
              :''}
              
            </td>
        );
    }
}

export default connect()(Setting);